<template>
  <iframe
    :id="iframeId"
    ref="iframeRef"
    :class="$style.testCameraForm"
    :src="configuration.url.toString()"
  />
</template>

<script setup lang="ts">
import { v } from 'h3-valibot';
import type { ITechnicalComponent } from '~/lib/ContentfulService';
import { parseURL } from '~/utils/validation/parseURL';
import { useIframeResizer } from '~/composables/useIframeResizer';

interface Props {
  item: ITechnicalComponent;
}

const props = defineProps<Props>();
const requestUrl = useRequestURL();

const iframeRef = ref<HTMLIFrameElement>();
const configurationSchema = v.object({
  url: parseURL
});

const configuration = computed(() => {
  const parsed = v.parse(configurationSchema, props.item.fields.configuration);

  requestUrl.searchParams?.forEach((value, key) => {
    parsed.url.searchParams.append(key, value);
  });

  return parsed;
});

const iframeId = computed(() => `test-camera-form-iframe-${props.item.sys.id}`);

if (configuration.value.url) {
  useHead({
    link: [
      {
        rel: 'preload',
        href: () => configuration.value.url.toString(),
        as: 'document'
      }
    ]
  });

  useIframeResizer(iframeRef, iframeId.value);
}
</script>

<style module>
.testCameraForm {
  width: 100%;
}
</style>
